import { useLocation } from 'react-router-dom';
import dayjs from 'dayjs';
import { FC } from 'react';
import { DashboardPage, FilterValuesStrings } from './dashboard.page';
import { Box } from '@mui/material';
import { decryptFiltersFromQuery } from '../utils/generatePublicDasboardLink.util';
import { useGetDistrictQuery } from '../../../store/api/district.api';

export const PublicDashboardPage: FC = () => {
	const location = useLocation();
	const query = new URLSearchParams(location.search);
	const encrypted = query.get('data');

	const decryptedFilters = encrypted ? decryptFiltersFromQuery(encrypted) : null;

	const start = decryptedFilters?.duration?.[0] ? dayjs(decryptedFilters.duration[0]).toDate() : null;
	const end = decryptedFilters?.duration?.[1] ? dayjs(decryptedFilters.duration[1]).toDate() : null;

	const duration: [Date | null, Date | null] = [start, end];

	const transformedFilterValues: FilterValuesStrings = {
		districtIds: decryptedFilters?.districtIds || '',
		engagementTypes: decryptedFilters?.engagementTypes || '',
		schoolIds: decryptedFilters?.schoolIds || '',
		programIds: decryptedFilters?.programIds || '',
		serviceIds: decryptedFilters?.serviceIds || '',
		providerIds: decryptedFilters?.providerIds || '',
		languages: decryptedFilters?.languages || '',
		engagementStatuses: decryptedFilters?.engagementStatuses || '',
		duration,
	};
	const districtId = decryptedFilters?.districtIds?.split(',')?.[0] || null;
	const { data: currentDistrict } = useGetDistrictQuery({ id: districtId }, { skip: !districtId });

	return (
		<Box sx={{ overflowY: 'auto', height: '100vh' }}>
			<DashboardPage
				transformedFilterValues={transformedFilterValues}
				isReadOnly
				isPublic
				isAdminRoute={false}
				currentDistrictId={districtId}
				currentDistrict={currentDistrict}
			/>
		</Box>
	);
};
